/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReportRunResponse,
    ReportRunResponseFromJSON,
    ReportRunResponseToJSON,
    ReportingTimeBucket,
    ReportingTimeBucketFromJSON,
    ReportingTimeBucketToJSON,
    RunReportRequest,
    RunReportRequestFromJSON,
    RunReportRequestToJSON,
} from '../models';

export interface ReportsRunReportRequest {
    runReportRequest?: RunReportRequest;
}

export interface ReportsUsageReportRequest {
    period?: ReportingTimeBucket;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     */
    async reportsRunReportRaw(requestParameters: ReportsRunReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportRunResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Reports/run-report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunReportRequestToJSON(requestParameters.runReportRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportRunResponseFromJSON(jsonValue));
    }

    /**
     */
    async reportsRunReport(requestParameters: ReportsRunReportRequest, initOverrides?: RequestInit): Promise<ReportRunResponse> {
        const response = await this.reportsRunReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reportsUsageReportRaw(requestParameters: ReportsUsageReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.period !== undefined) {
            queryParameters['period'] = requestParameters.period;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Reports/usage-report`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async reportsUsageReport(requestParameters: ReportsUsageReportRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.reportsUsageReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
